import { render, staticRenderFns } from "./physiologicalGoodsDetails.vue?vue&type=template&id=9f476bb0&scoped=true&"
import script from "./physiologicalGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./physiologicalGoodsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f476bb0",
  null
  
)

component.options.__file = "physiologicalGoodsDetails.vue"
export default component.exports